module.exports = __webpack_public_path__ + "static/media/deleteVacation.e6845129.svg";